import { canvasPaint } from "./native-gradient";
import { measuredWidth, onTextCacheReset } from "./text-cache";
const labels = new Map<string, string[]>();
onTextCacheReset(() => labels.clear());
import {
  type RenderContext,
  type RenderImages,
  imageSize,
} from "./canvas-surface";
import type { SceneNode, SceneAsset } from "../scene/model";

import { nodeMatrix } from "../native/transforms";
import { roleNames, type InteractiveRole } from "../native/interactive";
/** Labels and role images are a renderer concern; the document contains no child renderer objects. */
export function paintInteractiveLabel(
  ctx: RenderContext,
  node: SceneNode,
  assets: SceneAsset[],
  images: RenderImages,
) {
  const m = nodeMatrix(node),
    w = node.geometry.width!,
    h = node.geometry.height!,
    i = node.interaction;
  ctx.save();
  ctx.transform(m[0] / w, m[1] / w, m[2] / h, m[3] / h, m[4], m[5]);
  if (i.interactiveImageEnabled && node.media.interactiveImage) {
    const source = assets.find(
        (a) => a.id === node.media.interactiveImage,
      )?.source,
      image = source ? images.get(source) : null;
    if (image) {
      const size = imageSize(image),
        scale = Math.min(w / size.width, h / size.height);
      ctx.drawImage(
        image,
        (-size.width * scale) / 2,
        (-size.height * scale) / 2,
        size.width * scale,
        size.height * scale,
      );
    }
  } else {
    const size = Number(i.fontSize) || 20;
    ctx.font = `${size}px "${String(i.fontFamily || "Arial").replace(/["\\]/g, "")}"`;
    ctx.fillStyle = canvasPaint(
      ctx,
      String(i.textColor || "#000000"),
      i.textGradient,
      w,
      h,
    );
    ctx.globalAlpha *= Number(i.textAlpha ?? 1);
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    const text = String(
      i.displayText ||
        (i.role === "inputField"
          ? "Введите ответ"
          : roleNames[i.role as InteractiveRole]),
    );
    if (i.nativeInputValue) {
      ctx.beginPath();
      ctx.rect(-w / 2 + 10, -h / 2, w - 20, h);
      ctx.clip();
      const wide = measuredWidth(ctx, text) > w - 20;
      if (wide) ctx.textAlign = "left";
      ctx.fillText(
        text,
        wide ? -w / 2 + 10 - Number(i.nativeInputScrollLeft || 0) : 0,
        0,
      );
      ctx.restore();
      return;
    }
    const key = JSON.stringify([ctx.font, text, w]);
    let lines = labels.get(key);
    if (!lines) {
      lines = [];
      for (const paragraph of text.split("\n")) {
        let line = "";
        for (const word of paragraph.split(" ")) {
          const next = line ? line + " " + word : word;
          if (line && measuredWidth(ctx, next) > Math.max(40, w - 20)) {
            lines.push(line);
            line = word;
          } else line = next;
        }
        lines.push(line);
      }
      if (text.length < 2048) {
        if (labels.size >= 128) labels.delete(labels.keys().next().value!);
        labels.set(key, lines);
      }
    }
    lines.forEach((line, k) =>
      ctx.fillText(line, 0, (k - (lines.length - 1) / 2) * size * 1.13),
    );
  }
  ctx.restore();
}
